import { useState } from "react";
import { Search, X } from "lucide-react";
import { inputCls } from "../components/ui";

const NOMINATIM = "https://nominatim.openstreetmap.org/search";

// Public OSM geocoder, restricted to São Tomé e Príncipe; failures fall back to tapping the map.
export default function PlaceSearch({ onPick, placeholder, testid }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  const search = async (e) => {
    e.preventDefault();
    if (q.trim().length < 3) return;
    setBusy(true);
    try {
      const url = `${NOMINATIM}?format=json&limit=5&countrycodes=st&viewbox=6.3,1.8,7.6,-0.1&bounded=1&accept-language=pt&addressdetails=1&q=${encodeURIComponent(q.trim())}`;
      const res = await fetch(url, { headers: { Accept: "application/json" } });
      const data = res.ok ? await res.json() : [];
      const area = (a = {}) => a.suburb || a.village || a.town || a.city || a.county;
      setItems(data.map((r) => ({ label: [r.name || r.display_name.split(",")[0], area(r.address)].filter(Boolean).join(", "), lat: Number(r.lat), lng: Number(r.lon) })));
    } catch { setItems([]); } finally { setBusy(false); }
  };
  const pick = (it) => { onPick({ lat: it.lat, lng: it.lng, label: it.label.slice(0, 120) }); setItems(null); setQ(it.label); };
  return (
    <form onSubmit={search} data-testid={testid}
      onKeyDown={(e) => { if (e.key === "Escape") setItems(null); }}
      onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) setTimeout(() => setItems(null), 150); }}>
      <div className="relative">
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder} className={`${inputCls} pr-10`} data-testid={`${testid}-input`} />
      <button type="submit" className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500" aria-label="Pesquisar" data-testid={`${testid}-btn`}>
        <Search className={`h-4 w-4 ${busy ? "animate-pulse" : ""}`} />
      </button>
      </div>
      {items && (
        <ul className="mt-1 w-full overflow-hidden rounded-xl border border-gray-100 bg-white text-sm shadow-lg" data-testid={`${testid}-results`}>
          <li className="flex justify-end"><button type="button" onClick={() => setItems(null)} className="px-2 pt-1 text-gray-400" aria-label="Fechar" data-testid={`${testid}-close`}><X className="h-3.5 w-3.5" /></button></li>
          {!items.length && <li className="p-3 text-gray-500">Sem resultados. Marque o ponto no mapa.</li>}
          {items.map((it, i) => <li key={i}><button type="button" onClick={() => pick(it)} className="w-full p-3 text-left hover:bg-bo-bg" data-testid={`${testid}-result-${i}`}>{it.label}</button></li>)}
        </ul>
      )}
    </form>
  );
}
